import { render, staticRenderFns } from "./ModuloEnfermagem.vue?vue&type=template&id=cd240998&"
import script from "./ModuloEnfermagem.vue?vue&type=script&lang=js&"
export * from "./ModuloEnfermagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports